<template>
  <div class="replacementmonthlystatistics__report__view">    
    <div class="reports__subheader">
      <submit-panel @submit="createClick" text="Opret gruppe" 
               v-if="hasEditRights">
      </submit-panel>
    </div>
    <b-table :data="groups"
             :loading="loading"
             @click="editClick"
             hoverable>

      <b-table-column field="groupName"
                      label="Navn"
                      v-slot="props">
        {{ props.row.title }}
      </b-table-column>
      
      <b-table-column field="atWorkWeekDays"
                      label="Hverdage"
                      v-slot="props">
        {{ props.row.atWorkWeekDays }}
      </b-table-column>
      
      <b-table-column field="atWorkWeekSaturday"
                      label="Lørdage"
                      v-slot="props">
        {{ props.row.atWorkWeekSaturday }}
      </b-table-column>
      
      <b-table-column field="atWorkWeekSunday"
                      label="Søndage"
                      v-slot="props">
        {{ props.row.atWorkWeekSunday }}
      </b-table-column>
      
      <b-table-column>
        <span>
          <b-icon pack="fas"
                  icon="angle-right"></b-icon>
        </span>
        <template v-slot:header>
        </template>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiState from "../../enums/APISTATE";
import moment, { ISO_8601 } from 'moment';
import SubmitPanel from '@/components/report/SubmitPanel.vue';

export default {
  name: "groups-view",
  components: {SubmitPanel},
  data: () => ({  }),
  async mounted() {
    await this.getAllGroups();
  },
  computed: {
    ...mapGetters("groupStore", ["groupApiState", "groups"]),
    ...mapGetters(["currentUser", "hasEditRights"]),
     loading() {
      return this.groupApiState !== ApiState.LOADED;
    },
  },
  methods: {
    ...mapActions("groupStore", ["getAllGroups"]),
    dateFormat(arg) {
        return moment(arg).format('YYYY-MM-DD');
    },
    editClick(row) {
      this.$router.push(`/configuration/groups/${row.id}/group`);
    },
    createClick() {
      this.$router.push("/configuration/groups/new");
    },
  },
};
</script>

<style lang="scss" scoped>
.users-view {
  .register-user {
    cursor: pointer;
    width: 100%;
  }
}

.table td {
  text-align: left !important;
}
</style>
